import React from "react";

const SvgMidConfidence = (props) => (
  <svg width={68} height={66} {...props}>
    <g transform="translate(-.001)" fill="none" fillRule="evenodd">
      <ellipse
        stroke="#F4FFF5"
        strokeWidth={3.78}
        cx={33.5}
        cy={32.838}
        rx={31.61}
        ry={30.948}
      />
      <path
        d="M33.112 63.616c18.184 0 31.871-13.89 31.871-31.508S50.465 2.397 32.281 2.397"
        stroke="#9BFFA4"
        strokeWidth={4.08}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgMidConfidence;
